// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2EI1z","buttons":"PendingPaymentAlert_buttons__2UMfY"};